import React, { useState, Fragment, useEffect } from 'react';
import {
    Row, Card, Input, DropdownMenu,
    DropdownItem, UncontrolledDropdown,
    DropdownToggle, Button
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import TuneIcon from '@material-ui/icons/Tune';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import ReactTable from 'react-table';
import DataTablePagination from '../../../../../../components/DatatablePagination';

export default function ShowOrders({ onstartDateChange, handleSearchfilter, onEndDateChange, handleSubmit, orderList, handleViewOrderClick }) {

    const [searchOrder, setSearchOrder] = useState("");
    const [dropDown, setDropDown] = useState(" All");
    const [startDate, setStartDate] = useState(moment().subtract(15, 'days'));
    const [endDate, setEndDate] = useState(moment());

    const dataTableColumns = [
        {
            Header: 'Order Number',
            accessor: 'orderNumber',
            Cell: props => <p style={{ marginLeft: "10%" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Voucher Number',
            accessor: 'voucherNumber',
            Cell: props => <p style={{ marginLeft: "10%" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Voucher Name',
            accessor: 'name',
            Cell: props => <p style={{ marginLeft: "10%" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Discount',
            accessor: 'discount',
            Cell: props => <p style={{ marginLeft: "15%" }} >{props.value + ' %'} </p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Status',
            accessor: 'status',
            Cell: props => <p style={{ marginLeft: "12%", color: `${props.value.trim() === "Failed" ? "red" : "darkgreen"}` }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset' }
        },

        {
            Header: 'Order Email',
            accessor: 'email',
            Cell: props => <p style={{ marginLeft: "12%" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Amount',
            accessor: 'discountedPrice',
            Cell: props => <p style={{ marginLeft: "12%" }} >{props.row._original.currency.toUpperCase()} {props.value}</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Created Date',
            accessor: 'createdDate',
            Cell: props => <p style={{ marginLeft: "10%" }} >{moment(props.value).format("DD-MM-YYYY hh:mm:ss A")}</p>,
            style: { 'whiteSpace': 'unset' }
        }
    ];
    const handleClick = (id, data) => {
        setSearchOrder("");
        handleViewOrderClick(id, data);
    };
    const handleSearchfilterDate = date => {
        setStartDate(date);
        onstartDateChange(date);
    };
    const handleSearchfilterEndDate = date => {
        setEndDate(date);
        onEndDateChange(date);
    };

    return (
        <Fragment>

            <Row className="col-md-12">
                <Colxx xxs="2" md="2" className="mb-2">
                    <UncontrolledDropdown className="mr-1 float-md-left btn-group mb-1">
                        <DropdownToggle caret color="outline-dark" size="xs" >
                            Status
                            {dropDown}
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem
                                key="2"
                                value="All"
                                onClick={(e) => {
                                    setDropDown(" All");
                                    handleSearchfilter(searchOrder, e.target.value);
                                }}
                            >        All
                            </DropdownItem>
                            <DropdownItem
                                key="1"
                                value="Success"
                                onClick={(e) => {
                                    setDropDown(" Success");
                                    handleSearchfilter(searchOrder, e.target.value);
                                }}
                            >        Success
                            </DropdownItem>
                            <DropdownItem
                                key="0"
                                value="Failed"
                                onClick={(e) => {
                                    setDropDown(" Failed");
                                    handleSearchfilter(searchOrder, e.target.value);
                                }}
                            >        Failed
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </Colxx>
            </Row>
            <Row className="col-md-12">
                <Colxx xxs="2" md="2" className="mb-2">
                    <div className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top">
                        <Input value={searchOrder} className="form-control" placeholder="Search" onChange={(e) => {
                            setSearchOrder(e.target.value);
                            handleSearchfilter(e.target.value, dropDown);
                        }}></Input>     </div>
                </Colxx>

            </Row>
            <Row className="col-md-12">
                {(
                    <Fragment>
                        <Colxx xxs="12" md="2" className="mb-2">
                            <DatePicker
                                selected={startDate}
                                onChange={handleSearchfilterDate}
                                placeholderText="Start Date"
                                dateFormat="DD/MM/YYYY"
                            />
                        </Colxx>
                        <Colxx xxs="12" md="2" className="mb-2">
                            <DatePicker
                                selected={endDate}
                                onChange={handleSearchfilterEndDate}
                                placeholderText="End Date"
                                dateFormat="DD/MM/YYYY"
                            />
                        </Colxx>
                        <Colxx xxs="12" md="1" className="mb-2">
                            <Button
                                color="primary"
                                className="mb-2"
                                onClick={() => { handleSubmit(); }}
                            >
                                <IntlMessages id="forms.submit" />
                            </Button>
                        </Colxx>
                    </Fragment>
                )
                }

            </Row >
            <Row className="col-md-12">
                <Colxx xxs="12">
                    <Card className="d
                    -flex flex-row mb-3">
                        <Fragment>
                            <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                                {orderList ? (
                                    <ReactTable
                                        data={orderList}
                                        columns={dataTableColumns}
                                        defaultPageSize={10}
                                        filterable={false}
                                        showPageJump={true}
                                        PaginationComponent={DataTablePagination}
                                        showPageSizeOptions={true}
                                        className="-striped -highlight -bordered"

                                        style={{ width: "100%" }}
                                    />
                                ) : ""
                                }
                            </div>
                        </Fragment>
                    </Card>
                </Colxx>
            </Row>
        </Fragment >
    );
}

